import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap';
import HomeRouteCard from './components/HomeRouteCard'
import { getRoutesForHome } from './config/routesConfig';

// pendientes
//En la parte de pendiente de pagar no se puede eliminar
//en la parte donde se paga no esta el nombre de quien es el tiempo extra, solciitante, aprobador
//en el requestpendingtopay no refresca cuando se edita el cambio de pago

const getUserAndRole = () => {
    let userId = localStorage.getItem('userId') ? parseInt(localStorage.getItem('userId')) : 0;
    let roleId = localStorage.getItem('roleId') ? parseInt(localStorage.getItem('roleId')) : 0;
    return { userId, roleId }
};

function Home() {
    const [data, setData] = useState([]);

    useEffect(() => {
        const { roleId } = getUserAndRole();
        setData(getRoutesForHome(roleId));
    }, []);

    return (
        <Row>
            {data.map((item, index) => (
                <Col xl={3} key={index}>
                    <HomeRouteCard element={item} />
                </Col>
            ))}
        </Row>
    )
}

export default Home;